<template>
  <div class="Page">
    <div class="location Page-Content">
      <div class="location-info select-none">
        <!-- <div style="background-color: #08080881;color: white;padding: 10px 0;font-weight: 600;cursor: pointer;"
        @click="mapslistType = !mapslistType"
        >Select</div> -->
        <div style="font-size: 1.5rem;font-weight: 500;">All Within <br />
          Minutes’ Reach</div>
        <div v-for="(item,a) in LocationList" :key="a" >
          <div  style="background-color: black;height: 2px;width: 100%;"></div>
            <div class="btns row" style="justify-content: space-between;margin: 10px 0;" @click="ShowImgs(item,a)">
              <div class="row">
                <img class="btns-logo" style="width: 17px;" :src="item.logo" alt="">
                <img  v-if="item.Name == 'Shop & Dine'" style="margin-left: 0;" class="btns-logo" src="@/assets/location/logo/dine.png" alt="">
                <div class="title-text">{{item.Name}}</div>
              </div>
              <div>
                <div v-if="item.isShow" class="select-btns" ></div>
                <div v-else class="select-btns" style="background-color: white;border: 1px solid #000;"></div>
              </div>
            </div>
            <div class="btn-info" v-if="item.isShow">
              <div class="btn-info-line row" v-for="(item1,i) in item.minList" :key="i" style="justify-content: space-between;">
                <div class="row">
                  <div class="info-text" style="margin-right: 2px;">{{item1.tabName}}</div>
                  <img v-if="item1.logo" class="btns-logo" :src="item1.logo" alt="">
                  <img v-if="item1.tabName == 'Jurong East MRT Interchange'" class="btns-logo" src="@/assets/location/logo/mrt7.png" alt="">
                  <img v-if="item1.tabName == 'Jurong East MRT Interchange'" class="btns-logo" src="@/assets/location/logo/mrt6.png" alt="">
                </div>
                <div class="row">
                  <img v-if="item1.rightLogo == 'car'" class="btns-logo" src="@/assets/location/logo/car.png" alt="">
                  <img v-else class="btns-logo" src="@/assets/location/logo/people.png" alt="">
                  <div class="info-text" style="width: 35px;text-align: end;">{{item1.time}} min</div>
                </div>
              </div>
              <div @click="showIMG(item)" class="row" style="justify-content: start;">
                <img style="width: 15px;margin: 5px;height: 15px;" src="@/assets/btn/info.png" alt="">
                <span style="font-size: 12px;">More Info</span>
              </div>
            </div>
        </div>

        <div style="margin: 5px 0;">Legend</div>
        <div class="Legend-list">
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/mrt8.png" alt="">
              <div class="info-text">East-West Line</div>
          </div>
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/mrt7.png" alt="">
              <div class="info-text">North-South Line</div>
          </div>
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/mrt6.png" alt="">
              <div class="info-text">Jurong Region Line (U/C)</div>
          </div>
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/mrt5.png" alt="">
              <div class="info-text">Downtown Line</div>
          </div>
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/mrt4.png" alt="">
              <div class="info-text">Cross Island Line</div>
          </div>
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/mrt2.png" alt="">
              <div class="info-text">North-East Line</div>
          </div>
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/mrt1.png" alt="">
              <div class="info-text">Circle Line</div>
          </div>
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/mrt3.png" alt="">
              <div class="info-text">Thomson-East Coast Line</div>
          </div>
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/line.png" alt="">
              <div class="info-text">Park Connectors</div>
          </div>
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/line1.png" alt="">
              <div class="info-text">Park Connectors (U/C)</div>
          </div>
          <div class="row">
            <img class="btns-logo" src="@/assets/location/logo/pin.png" alt="">
              <div class="info-text">Future Developments</div>
          </div>
        </div>
        <div style="font-size: 8px;font-style: italic;margin: 5px 0;">
          Travel time is estimate only from google maps and based on optimal conditions. Every reasonable care 
          has been taken in the preparation of the location map. The map is printed as at (date of print). For 
          information on the permissible land use and density of sites around the housing project, the intending 
          Purchaser may refer to the Master Plan available from the website of the Urban Redevelopment 
          Authority at www.ura.gov.sg.
        </div>
        <!-- <div v-show="mapslistType" class="location-list" :class="{setBtn:item1.showType}" @click="setlistType(item1,i1)" v-for="(item1,i1) in LocationList" :key="i1">
          <p style="margin: 0;">{{ item1.Name }}</p>
        </div> -->
      </div>
      <div class="location-img">
        <img  ondragstart="return false;" src="@/assets/location/maps/bg.png" alt="">
        <img v-if="item.isShow || FirstEntry" style="border: 0;" :class="{growFromOpacityAnimation:!FirstEntry}"  ondragstart="return false;" v-for="(item,i) in LocationList" :key="i" :src="item.img" alt="">
        <img  ondragstart="return false;" src="@/assets/location/maps/logo.png" alt="">
      </div>

      <img class="AerialPhotography" @click="PopVrType = true" src="@/assets/btn/camera-drone.png" alt="">

    </div>
    <div v-if="PopMapType" class="pop-win-content row">
      <!-- <div> title</div> -->
      <!-- <img src="@/assets/location/maps/logo.png" alt=""> -->
      <mapSwiper @sendData="handleChildEvent" :imgList="PopImgList" />
      <div @click="PopMapType = false"  style="position: absolute;width: 100%;height: 100%;top: 0;left: 0; background-color: #0000007c;"></div>
      <!-- <img @click="PopMapType = false" style="position: absolute;top: calc(7% - 40px);right: calc(10% - 80px);background-color: white;width: 35px;height: 35px;z-index: 120;" src="@/assets/btn/close.png"> -->
    </div>
        <!-- 其他媒体 -->
      <div v-if="PopVrType" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-color: black;z-index: 2000;">
        <iframe style="width: 100%;height: 100%;" src="https://www.mixgovr.com/AUDAX/pinegroveshowflat-drone/" frameborder="0"></iframe>
      <div @click="PopVrType=false" style="position: absolute;top: 49%;right: 20px;color: black;background-color: white;padding: 5px;cursor: pointer;border-radius: 5px;">Close</div>
    </div>
  </div>

</template>


<script>
import mapSwiper from './mapSwiper.vue';

export default {
  components:{
    mapSwiper
  },


  data() {
    return {
      PopVrType:false,
      FirstEntry:true,
      PopMapType:false,
      PopImgList:{},
      // mapslistType:true,
      // nowLocation:{},
      LocationList:[
      {
          Name:'Connectivity',
          isShow:false,
          logo:require('@/assets/location/logo/mrt.png'),
          img:require('@/assets/location/maps/MRT.png'),
          minList:[
            {tabName:"Dover MRT",rightLogo:"car",time:"4",logo:require('@/assets/location/logo/mrt8.png')},
            {tabName:"Clementi MRT",rightLogo:"car",time:"4",logo:require('@/assets/location/logo/mrt8.png')},
            {tabName:"King Albert Park MRT",rightLogo:"car",time:"7",logo:require('@/assets/location/logo/mrt5.png')},
            {tabName:"Jurong East MRT Interchange",rightLogo:"car",time:"10",logo:require('@/assets/location/logo/mrt8.png')},
            {tabName:"Maju MRT (U/C)",rightLogo:"car",time:"3",logo:require('@/assets/location/logo/mrt4.png')},
          ],
          PopImgList:{
            title:"Next Stop, Everywhere",
            content:"Nava Grove is also within proximity to multiple MRT lines that connect islandwide, including the East-West Line (Dover MRT & Clementi MRT), North-South Line and Jurong Region Line (Jurong East MRT Interchange), Downtown Line (King Albert Park MRT), Circle Line (Buona Vista & Holland Village MRT), and upcoming Cross Island Line (Clementi MRT & Maju MRT U/C)",
            imglist:[
            {name:"01",logo:require('@/assets/location/pop-img/CONNECTIVITY/CONNECTIVITY BROCHURE.png')},
            {name:"01",logo:require('@/assets/location/pop-img/CONNECTIVITY/Clementi MRT.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/CONNECTIVITY/Dover MRT.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/CONNECTIVITY/Jurong East MRT Interchange.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/CONNECTIVITY/King Albert Park MRT.jpg')},
          ],
          }
        },
      {
          Name:'Renowned Schools',
          isShow:false,
          logo:require('@/assets/location/logo/schools.png'),
          img:require('@/assets/location/maps/School.png'),
          minList:[
            {tabName:"Singapore University of Social Sciences (SUSS)",rightLogo:"car",time:"3"},
            {tabName:"Pei Tong Primary School",rightLogo:"car",time:"4"},
            {tabName:"Henry Park Primary School",rightLogo:"car",time:"4"},
            {tabName:"Singapore Polytechnic",rightLogo:"car",time:"4"},
            {tabName:"National University of Singapore (NUS)",rightLogo:"car",time:"4"},
            {tabName:"Ngee Ann Polytechnic",rightLogo:"car",time:"7"},
            {tabName:"Methodist Girls’ School",rightLogo:"car",time:"7"},
            {tabName:"United World College of South East Asia (UWCSEA)",rightLogo:"car",time:"7"},
          ],
          PopImgList:{
            title:"Renowned Education Belt",
            content:"Located near Kent Ridge and Dover education belt, Nava Grove offers unparalleled access to top educational institutions. Henry Park Primary School, Pei Tong Primary School, Methodist Girls’ School, along with renowned universities and international schools, are all a short distance away.",
            imglist:[
            {name:"01",logo:require('@/assets/location/pop-img/SCHOOL/SCHOOL BROCHURE.png')},
            {name:"01",logo:require('@/assets/location/pop-img/SCHOOL/Henry Park Primary School.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/SCHOOL/Methodist Girls’ School.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/SCHOOL/National University of Singapore.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/SCHOOL/Pei Tong Primary School.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/SCHOOL/Singapore Polytechnic.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/SCHOOL/Singapore University of Social Sciences.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/SCHOOL/United World College of South East Asia.jpg')},
          ],
          }
        },

        {
          Name:'Nature',
          isShow:false,
          logo:require('@/assets/location/logo/nature.png'),
          img:require('@/assets/location/maps/Nature.png'),
          minList:[
            {tabName:"Clementi Forest",rightLogo:"people",time:"2"},
            {tabName:"Ulu Pandan Park Connector",rightLogo:"people",time:"4"},
            {tabName:"Dover Forest",rightLogo:"people",time:"13"},
            {tabName:"Rail Corridor",rightLogo:"people",time:"15"},
          ],
          PopImgList:{
            title:"Surrounded by Nature",
            content:"Just minutes from Nava Grove, pristine urban parks and untouched forests beckon, offering the perfect escape for families seeking a day out in nature. Whether it’s strolling through leafy trails or soaking in the serene surroundings, you are never far from nature.",
            imglist:[
            {name:"01",logo:require('@/assets/location/pop-img/NATURE/NATURE BROCHURE.png')},
            {name:"01",logo:require('@/assets/location/pop-img/NATURE/Clementi Forest.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/NATURE/Dover Forest.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/NATURE/Jurong Lake Gardens.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/NATURE/Rail Corridor.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/NATURE/Singapore Botanic Gardens.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/NATURE/Ulu Pandan Park Connector.jpg')},
          ],
          }
        },
        {
          Name:'Shop & Dine',
          isShow:false,
          logo:require('@/assets/location/logo/shop.png'),
          img:require('@/assets/location/maps/Lifestyle Enclave.png'),
          minList:[
            {tabName:"Clementi Mall",rightLogo:"car",time:"5"},
            {tabName:"One Holland Village",rightLogo:"car",time:"5"},
            {tabName:"The Star Vista",rightLogo:"car",time:"6"},
            {tabName:"Dempsey Hill",rightLogo:"car",time:"9"},
            {tabName:"Jem",rightLogo:"car",time:"9"},
            {tabName:"IMM Mall",rightLogo:"car",time:"9"},
            {tabName:"Westgate",rightLogo:"car",time:"10"},
            {tabName:"Ion Orchard",rightLogo:"car",time:"12"},
          ],
          PopImgList:{
            title:"Everyday Essentials, Elevated",
            content:"Embrace a chic lifestyle as you explore the trendy enclaves and vibrant malls in the vicinity. From stylish boutiques to delectable eateries, all your daily necessities are conveniently within reach.",
            imglist:[
            {name:"01",logo:require('@/assets/location/pop-img/LIFESTYLE/LIFESTYLE FOR BROCHURE.png')},
            {name:"01",logo:require('@/assets/location/pop-img/LIFESTYLE/Clementi Mall.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/LIFESTYLE/Dempsey Hill.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/LIFESTYLE/ION Orchard.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/LIFESTYLE/JEM.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/LIFESTYLE/One Holland Village.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/LIFESTYLE/Sunset Way.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/LIFESTYLE/The Star Vista.jpg')},
          ],
          }
        },

        {
          Name:'Business Park',
          isShow:false,
          logo:require('@/assets/location/logo/park.png'),

          img:require('@/assets/location/maps/Business Park.png'),
          minList:[
            {tabName:"Singapore Science Park I & II",rightLogo:"car",time:"8"},
            {tabName:"one-north Business Park",rightLogo:"car",time:"8"},
            {tabName:"Jurong Lake District (U/C)",rightLogo:"car",time:"12"}
          ],
          PopImgList:{
            title:"Thriving Business Hubs",
            content:"Get connected to the pulse of innovation even from the tranquil heart of Nava Grove. About 10 minutes’ drive away, the Singapore Science Park is home to over 350 multinationals, companies, and laboratories, while the sprawling one-north district hosts over 400 leading companies and 50,000 professionals.",
            imglist:[
            {name:"01",logo:require('@/assets/location/pop-img/BUSINESS PARKS/BUSINESS PARKS BROCHURE.png')},
            {name:"01",logo:require('@/assets/location/pop-img/BUSINESS PARKS/one-north Business Park.jpg')},
            {name:"01",logo:require('@/assets/location/pop-img/BUSINESS PARKS/Singapore Science Park I & II.jpg')},
          ],
          }
        },

      ]
    }
  },
  methods: {
    ShowVR(){

    },
    ShowImgs(item,i){
      this.LocationList[i].isShow = !this.LocationList[i].isShow
      this.FirstEntry = this.LocationList.every(item => item.isShow === false)? true : false;

    },
    handleChildEvent(data) {
      this.PopMapType = data
      console.log('子组件传来的数据:', data);
    },
    showIMG(item){
      this.PopImgList = item.PopImgList
      this.PopMapType = true
    },
    setlistType(item,indexs){
      console.log(item);
      if(item.Name == 'ALL'){
        this.LocationList.forEach((location) => {
          // if (location.Name != 'ALL') {
            console.log(location.Name);
            if (item.showType) {
            location.showType = false; // Toggle the showType property
            } else {
            location.showType = true; // Toggle the showType property
            }
          // }
        });
      }
      else{
        // item.showType = !item.showType
        this.LocationList[indexs].showType = !item.showType
      }
    },
    goMessageInfo(url) {
      var type = "link"
      var url = "https://www.mixgovr.com/AUDAX/pinegroveshowflat-drone/"
      switch (type) {
        case "iframe":
          this.$router
            .push({
              path: '/Media', // 自定义窗口
              query: {
                mediaType: type,
                url:url
              },
            })
            .catch((err) => {});
          break;
        case "nwjs":
            // nwjs创建一个新窗口
            let newWindow = nw.Window.open(url, {
              width: 800,
              height: 800,
              title: url,
            });

            // 当新窗口关闭时触发的事件
            newWindow.on("closed", () => {
              newWindow = null;
            });
          break;
        case "link":
          window.open(url);
          break;
        default:
          window.open(url);
          break;
      }
      



    },
  },
  mounted(){
    // this.nowLocation = this.LocationList[0]
    // this.nowUnit = this.nowFloor.TypeList[0]
  }
}
</script>

<style lang="less">

.pop-win-content{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 300;
  overflow: hidden;

}




.btn-info-line{
  margin-bottom: 2px;
}

.Legend-list{
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  justify-items: start;
  grid-auto-flow: column;
}

.Legend-list .info-text{
  font-size: 8px !important;
}

.btns-logo{
  width: 15px;
  height: 15px;
  // margin: 5px 2px;
  margin-right: 2px;
  // margin-left: 2px;
  object-fit: contain;
}
.btns{
  margin: 5px 0;
}

.title-text{
  color: #4b4b4b;
  font-size: 12px;
}
.info-text{
  font-size: 10px;
  color: #4b4b4b;
}
.info-end-text{
  width: 35px;
  text-align: end;
}

.AerialPhotography{
  position: absolute;
  top: auto !important;
  bottom: 11% !important;
  left: 22%;
  width: 40px !important;
  height: 40px !important;
  z-index: 200;
  cursor: pointer;
  background-color: white;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 0 10px #707070;
}

.setBtn{
  background-color: #ffffff !important;
  color: #000000 !important;
  font-weight: 600;
}
  .location{
    overflow: hidden;
    display: flex;
    flex-direction: row;
    .location-img{
      width: calc(80% - 90px);
      height: calc(100% - 60px);
      margin: 30px;
      margin-right: 60px;
      // background-color: #000000;
      overflow: auto;
      position: relative;
      border-radius: 5px;
      z-index: 120;
      img{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        // height: auto !important;
        // max-height: 100%;
      }
    }
    .location-info{
      // position: absolute;
      // left: 20px;
      // top: 20px;
      width: calc(20% - 40px);
      height: calc(100% - 40px);
      color: #000000;
      text-align: start;
      overflow: auto;
      cursor: pointer;
      // background-color: #00000082;
      padding: 20px;
      // border-radius: 5px;
      .location-list{
        height: 40px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        // margin:0 20px;
        // margin-bottom: 1px;
        // margin-left: 1px;
        // padding-left: 35px;
        margin: 10px 0;
        border-radius: 5px;
        // border-radius: 10px;
        // border: 1px solid rgb(226, 0, 0);
        background-color: #08080881;
        color: white;
        user-select: none;
      }
    }
    
  }


</style>


